import { transparentGenerator } from './utils';

const PRIMARY = {
  lighter: '#CDEBF3',
  light: '#6AC3DA',
  main: '#006aff',
  link: '#4cacff',
  dark: '#509aff',
  darker: '#033845'
};

const SECONDARY = {
  lighter: '#C0C0C4',
  light: '#4B4C56',
  main: '#30313D',
  link: '#028bff',
  button: '#4B4C56',
  dark: '#1E1F2C',
  darker: '#191A25'
};

const INFO = {
  lighter: '#BEFFEE',
  light: '#6AFFDA',
  main: '#00CC99',
  dark: '#007A5C',
  darker: '#00523D'
};

const SUCCESS = {
  lighter: '#E9FCD4',
  light: '#AAF27F',
  main: '#54D62C',
  dark: '#229A16',
  darker: '#08660D'
};

const WARNING = {
  lighter: '#ffe1cc',
  light: '#ffa666',
  main: '#FF6B00',
  dark: '#994000',
  darker: '#662b00'
};

const ERROR = {
  lighter: '#FFE7D9',
  light: '#FFA48D',
  main: '#FF4842',
  dark: '#B72136',
  darker: '#7A0C2E'
};

const GREY = {
  100: '#EDEDEE',
  200: '#C0C0C4',
  300: '#54555F',
  400: '#4B4C56',
  500: '#42434E',
  600: '#30313D',
  650: '#272834',
  700: '#1E1F2C',
  800: '#191A25',
  900: '#101017'
};

const COMMON = {
  white: '#FFFFFF',
  black: '#000000'
};

const TRANSPARENT = {
  primary: { ...transparentGenerator(PRIMARY.main) },
  secondary: { ...transparentGenerator(SECONDARY.main) },
  error: { ...transparentGenerator(ERROR.main) },
  warning: { ...transparentGenerator(WARNING.main) },
  success: { ...transparentGenerator(SUCCESS.main) },
  info: { ...transparentGenerator(INFO.main) },
  white: { ...transparentGenerator(COMMON.white) },
  black: { ...transparentGenerator(COMMON.black) }
};

const AIO_TAB_BORDER = {
  endpointsTab: '#EF71EA',
  userTab: '#A983FF',
  sspmTab: '#00BBF5',
  emailTab: '#7DE6DA',
  xdrTab: '#C6BF1D',
  automationTab: '#DAA37B'
};

const ACCENT = {
  low: '#826AF9',
  medium: '#F99D2F',
  high: '#FF6B00',
  critical: '#ff4842',
  open: '#509aff',
  close: '#229A16',
  ignored: '#B72136',
  secondLow: '#FFE700'
};

const TEXT = {
  primary: '#FFFFFF',
  secondary: GREY[200],
  disabled: TRANSPARENT.white[48]
};

const BUTTON = {
  primary: '#006aff',
  primaryHover: '#509aff',
  secondary: '#42434E',
  secondaryHover: '#3662A6',
  outlineHover: '#509aff'
};

const BACKGROUND = {
  default: GREY[700],
  primary: '#232430',
  paper: GREY[600],
  paperish: GREY[650],
  scroll: '#4B4C56',
  scrollActive: '#006aff',
  cardBackground: '#30313b',
  filterBackground: '#181a25',
  cardBackgroundHover: '#54555F',
  cardBackgroundClick: '#104391'
};

const BORDER = {
  default: '#7D7E87',
  warning: '#FFC107',
  warningDarker: '#ffc10714',
  warningDark: '#ffc10729',
  outline: '#7EC8FF'
};

const palette = {
  mode: 'dark',
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  grey: GREY,
  text: TEXT,
  button: BUTTON,
  background: BACKGROUND,
  common: COMMON,
  divider: TRANSPARENT.white[12],
  transparent: TRANSPARENT,
  accent: ACCENT,
  border: BORDER,
  tabs: AIO_TAB_BORDER
} as const;

declare module '@mui/material/styles' {
  interface Palette {
    border: typeof palette.border;
    tabs: typeof palette.tabs;
  }
}

export default palette;
